export const FACETS_SUCCESS = 'FACETS_SUCCESS';
export const FACETS_ERROR = 'FACETS_ERROR';

export const ProductListHitsPerPage = 20;
export const ProductListHitsPerPageBlueWeeks = 24;
export const autocompleteHits = 6;
